/*
 * What the family history dialog holds. Every field the save sends comes from here, the
 * disease code included: the backend writes every column, so a field the dialog did not load
 * is saved as whatever the dialog happened to hold. For the disease code that was the
 * previous row's code, or `[]` (KIN-2198).
 */
export const EMPTY_FAMILY_HISTORY_FORM = {
  familyRelationship: "FATHER",
  medicalDetails: "",
  deceased: "NO",
  diseaseCode: null,
};

/** The dialog's values for editing `row`, or an empty dialog when there is no row. */
export const toFamilyHistoryForm = (row) => {
  if (!row) return EMPTY_FAMILY_HISTORY_FORM;

  return {
    familyRelationship:
      row.familyRelationship ?? EMPTY_FAMILY_HISTORY_FORM.familyRelationship,
    medicalDetails: row.medicalDetails ?? "",
    deceased: row.deceased ?? EMPTY_FAMILY_HISTORY_FORM.deceased,
    diseaseCode: row.diseaseCode || null,
  };
};
